import type { Tokens } from '../../../theming/types'
import { styles } from '../../../utilities'
import type { InputTextBoxProps } from '..'

export default (config: {
  props?: Partial<InputTextBoxProps>
  tokens: Tokens
}) => {
  const { tokens } = config
  return {
    default: {
      wrapper: {
        display: 'flex',
        background: tokens.formBgColorDefault,
        border: `1px solid ${tokens.formBorderColorDefault}`,
        borderRadius: '2px',
        width: '100%',
        outline: '1px solid transparent',
        outlineOffset: `-${tokens.focusWidth}`,
        transitionDuration: '100ms',
        transitionProperty: 'border, outline',

        '&:hover': {
          borderColor: tokens.formBorderColorHover,
        },
      },

      input: {
        ...tokens.fontBodyM,
        textOverflow: 'ellipsis',
        width: '100%',
        appearance: 'none',
        background: 'transparent',
        border: 'none',
        color: tokens.fontColorDefault,
        height: 'auto',
        margin: 0,

        /* remove chrome's default date/time icons */
        '::-webkit-calendar-picker-indicator': {
          display: 'none',
        },

        '&:disabled': {
          /* fix for Safari disabled input bug https://github.com/primer/css/pull/1707 */
          WebkitTextFillColor: tokens.fontColorDefault,
          cursor: 'not-allowed',
        },

        '&:read-only': {
          color: tokens.fontColorDefault,
        },

        /* Focus styles are applied to the wrapper */
        '&:focus': {
          outline: 'none',
        },

        '&::placeholder': {
          color: tokens.fontColorSubtle,
          opacity: 1,
        },

        ...styles.touchScreenFormFieldFontSize,
      },
    },

    hideNumberPickerSpinner: {
      input: {
        '&::-webkit-inner-spin-button': {
          appearance: 'none',
          margin: 0,
        },

        '&::-webkit-outer-spin-button': {
          appearance: 'none',
          margin: 0,
        },

        '&::-ms-clear': {
          display: 'none',
        },

        appearance: 'textfield',
      },
    },

    invalid: {
      wrapper: {
        borderColor: tokens.formBorderColorError,

        '&:hover': {
          borderColor: tokens.formBorderColorError,
        },
      },
    },

    disabled: {
      wrapper: {
        backgroundColor: tokens.formBgColorDisabled,
        opacity: tokens.opacityDisabled,

        '&:hover': {
          borderColor: tokens.formBorderColorDefault,
        },
      },
    },

    readOnly: {
      wrapper: {
        backgroundColor: tokens.formBgColorRead,
        borderColor: 'transparent',
      },
    },

    focus: {
      wrapper: {
        outline: `${tokens.focusWidth} solid ${tokens.formBorderColorActive}`,
        outlineOffset: `-${tokens.focusWidth}`,
        border: `1px solid ${tokens.formBorderColorActive}`,
      },
    },
  } as const
}
